<div class="login-page">

    <div class="form card-body">

        <div class="line-1 anim-typewriter">
      
            <!-- <h3 style="text-align: center; font-size: 30px;margin: 0 auto;font-weight: bold;color:#d97103">SICAI</h3>
            <p style="text-align: center; font-size: 18px;margin: 0 auto;font-weight: bold;color: rgb(151, 149, 148);">Sistema de Control de Almacén e Insumos</p>
       -->
         </div>

         <img src="./assets/images/NuevoSICAI.png" alt="" style="max-width: 100%;max-height: 100%;">

      <form (ngSubmit)="buscaUsuario(f,usuario.email,usuario.password); f.resetForm()" #f="ngForm" class="form-horizontal form-material login-form m-t-20">
        
        <small *ngIf="email.invalid && email.touched" class="form-text text-danger animated fadeIn">Olvido escribir su Usuario</small>
        <div class="form-group m-t-5">
            <div class="col-xs-12">
                <input [(ngModel)]="usuario.email" class="form-control" type="text" name="usuario" required placeholder="Usuario" #email="ngModel"/>
            </div>
        </div>


        <small *ngIf="password.invalid && password.touched" class="form-text text-danger animated fadeIn">Olvido escribir su contraseña</small>  
        <div class="form-group m-t-5">
            <div class="col-xs-12">
        <input [(ngModel)]="usuario.password" class="form-control" type="password" name="password" required placeholder="Contraseña" #password="ngModel"/>
    </div>
</div>

        <button type="submit">Entrar</button>

        <br>

      </form>
    </div>
  </div>
